import React, { useEffect, useRef, useState } from 'react';

import BaccaratCell from './BaccaratCell';
import { BaccaratValues } from './constants';
import { calculateFontSize, convertResultsToTable } from './helpers';

import style from './index.scss';

type BaccaratTableProps = {
    data: string[];
}

const BaccaratTable = ({ data }: BaccaratTableProps) => {
    const [baccaratResults, setBaccaratResults] = useState<string[]>([]);
    const baccaratTableRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const newResult = !data?.includes(BaccaratValues.ShoeChange)
            ? [...baccaratResults, ...data]
            : [];

        setBaccaratResults(newResult);
        // eslint-disable-next-line
    }, [data]);

    const fontSize = calculateFontSize(baccaratTableRef?.current);
    const result = convertResultsToTable(baccaratResults);

    return (
        <div className={style.container}>
            <div className={`baccarat-table-wrapper ${style.baccaratTableWrapper}`}>
                <div className={`${style.resultTable} baccarat-result-table`} ref={baccaratTableRef} style={{ fontSize }}>
                    {
                        result.map((row) => row.map((cell: string, idx) => {
                            return <BaccaratCell cell={cell} key={idx} />;
                        }))
                    }
                </div>
            </div>
        </div>
    );
};

export default BaccaratTable;
